import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import mapTilesTabsData from './mapTilesTabsData.json';
import CustomButton from '../../../../common/Button/CustomButton/CustomButton';
import MapTilesTabsDropdown from './MapTilesTabsDropdown';
import { isHideMapTilesState } from '../../../../../app/redux/retrievers/retrievers';
import { theme } from '../../../../../core/theme/theme';
import './styles/map.tiles.tabs.styles.css';

const MapTilesTabs = () => {
    const isHideMapTiles = useSelector(isHideMapTilesState);

    const [pickedValue, setPickedValue] = useState<number>(0);
    const [isActive, setIsActive] = useState<boolean>(false);

    return !isHideMapTiles ? (
        <div id="map-tiles-tabs" className="map-tiles-tabs">
            {mapTilesTabsData.map((tab: any) => (
                <div key={tab.value} className="map-tile-tab">
                    <CustomButton
                        onClick={() => {
                            if (!isActive) {
                                setPickedValue(tab.value);
                                setIsActive(true);
                            } else {
                                setPickedValue(0);
                                setIsActive(false);
                            }
                        }}
                        text={tab.tabTitle}
                        textColor={pickedValue === tab.value ? theme.colors.default : 'black'}
                        color={pickedValue === tab.value ? theme.colors.selected_color : theme.colors.default}
                        fontSize="11px"
                    />
                    <MapTilesTabsDropdown
                        isPicked={pickedValue === tab.value}
                        setPickedValue={setPickedValue}
                        setIsActive={setIsActive}
                        toggleButtons={tab.dropdown.buttons}
                    />
                </div>
            ))}
        </div>
    ) : (
        <></>
    );
};

export default MapTilesTabs;
